export const GET_EVENT_DETAILS_DATA = 'GET_EVENT_DETAILS_DATA'
export const SET_ED_RESPONSE = 'SET_ED_RESPONSE'
